<!--
 * @FileDescription: 考勤表单
 * @Author: wh
 * @Date: 2020-12-11 13:17:21
 * @LastEditors: 陈瑞军
 * @LastEditTime: 2021-10-19 16:53:43
-->
<template>
  <yxt-drawer
    v-drawerloading="loading"
   
    :before-close="beforeCloseHandle"
    :visible.sync="visible"
    direction="rtl"
    :size="parseInt(size)>parseInt(maxWidth)?maxWidth:size"
  >
  <slot name="title" slot="title">
    <div class=" version-header">
     <div>{{titleInternalKey?$t(titleInternalKey):title}}</div>
     <yxt-tag size="medium">版本：1.0</yxt-tag>
    </div>
  </slot>

    <div>
      <yxt-form ref="form" :model="form" :rules="rules">
        <yxt-form-item v-if="formCfg.nameShowState && type === '1'" :label="formCfg.name" prop="name">
          <yxt-input v-model="form.name" maxlength="200" :placeholder="$t('pc_ulcd_lbl_please_input', [formCfg.name ])" type="text" show-word-limit />
        </yxt-form-item>
        <!-- 签到时间 -->
        <template v-if="formCfg.signTimeShowState">
          <yxt-form-item :label="formCfg.signTime " prop="signTime">
            <yxt-date-picker
              v-model="form.signTime"
              type="datetimerange"
              :picker-options="signPickerOptions"
              :range-separator="$t('pc_ulcd_lbl_to')"
              :start-placeholder="$t('pc_ulcd_lbl_starttime')"
              :end-placeholder="$t('pc_ulcd_lbl_endtime')"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels
              clearable
              class="date-picker-w" />
          </yxt-form-item>
          <template v-if="form.signTime && form.signTime.length">
            <yxt-form-item v-if="formCfg.sigInPwdShowState" :label="formCfg.sigInPwd " class="yxt-form-item-level-2" prop="sigInPwd">
              <yxt-input v-model="form.sigInPwd" maxlength="20" class="yxt-ulcd-sign-pwd" />
            </yxt-form-item>
            <yxt-form-item v-if="formCfg.timeOfAllowLate" :label="formCfg.timeOfAllowLate " class="yxt-form-item-level-2" prop="timeOfAllowLate">
              {{ formCfg.lateFlag_allowLate[0] }}
              <yxt-input-number v-model="form.timeOfAllowLate" :controls="false" :min="0" :max="99999" :precision="0" class="w-100" />
              {{ formCfg.lateFlag_allowLate[1] }}<span v-if="lateMinuteRange" class="v-mid f-s-12 txt-grey">（{{ $t('pc_ulcd_lbl_delayrange') }}：{{ lateMinuteRange }}）</span>
            </yxt-form-item>
          </template>
        </template>
        <!-- 签退时间 -->
        <template v-if="formCfg.signoutTimeShowState">
          <yxt-form-item :label="formCfg.signoutTime " prop="signoutTime">
            <yxt-date-picker
              v-model="form.signoutTime"
              type="datetimerange"
              :picker-options="signoutPickerOptions"
              :range-separator="$t('pc_ulcd_lbl_to')"
              :start-placeholder="$t('pc_ulcd_lbl_starttime')"
              :end-placeholder="$t('pc_ulcd_lbl_endtime')"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels
              clearable
              class="date-picker-w" />
          </yxt-form-item>
          <yxt-form-item v-if="formCfg.sigOutPwdShowState && form.signoutTime && form.signoutTime.length" :label="formCfg.sigOutPwd " prop="sigOutPwd" class="yxt-form-item-level-2">
            <yxt-input v-model="form.sigOutPwd" maxlength="20" class="yxt-ulcd-sign-pwd" />
          </yxt-form-item>
        </template>
        <!-- 考勤定位地址 -->
        <yxt-form-item v-if="formCfg.locationNameShowState" :label="formCfg.locationName" prop="locationName" :rules="{ required: form.canFence === 1 &&!functionPoints.hidden&&!functionPoints.disabled, message: $t('pc_ulcd_placeholder_attendaddress'), trigger: 'change' }">
          <yxt-input v-model="form.locationName" readonly autocomplete="off" :placeholder="$t('pc_ulcd_placeholder_attendaddress')" >
            <yxt-link slot="suffix" :underline="false" class="layout-flex layout-align-center c-43 hand" @click="selectAdress"><i class="yxt-icon-location-outline mr4"></i><span>{{ $t('pc_ulcd_lbl_offline_mapaddress') }}</span></yxt-link>
          </yxt-input>
        </yxt-form-item>
        <!-- 考勤详细地址 -->
        <yxt-form-item v-if="formCfg.addressShowState" prop="address" class="mb10" :rules="{ required: form.canFence === 1, message: $t('pc_ulcd_placeholder_detailaddress'), trigger: 'blur' }">
          <yxt-input v-model="form.address" autocomplete="off" maxlength="50" :placeholder="$t('pc_ulcd_placeholder_detailaddress')" show-word-limit />
        </yxt-form-item>
        <!-- 开启电子围栏44 -->
        <yxt-form-item v-if="formCfg.canFenceShowState&&!functionPoints.hidden" prop="canFence" class="mb0">
          <yxt-col>
            <yxt-checkbox v-model="form.canFence" :disabled="functionPoints.disabled" :true-label="1" :false-label="2" >
              {{ $t('pc_ulcd_lbl_offline_enclosure') }}
            </yxt-checkbox>
            <yxt-tooltip
              :content="functionPoints.disabled ? $t('pc_ulcd_msg_permission_error') :$t('pc_ulcd_tip_clockintip')"
              class="item v-mid ml8"
              effect="light"
              placement="right"
            >
              <i class="yxt-icon-warning-outline"></i>
            </yxt-tooltip>
          </yxt-col>
        </yxt-form-item>
        <!-- 设置考勤范围 -->
        <yxt-form-item v-if="form.canFence===1 && !functionPoints.hidden" >
          <span class="mr4">{{ $t('pc_ulcd_lbl_attendScope') }}</span
          >
          <yxt-input-number
            v-model="form.attendanceRange"
            class="mr4 ml4"
            controls-position="right"
            :min="1"
            :max="20"
            step-strictly
            :disabled="functionPoints.disabled"
          ></yxt-input-number
          >
          <span class="mr4">{{ $t('pc_ulcd_lbl_attendScopeKm') }}</span
          >
        </yxt-form-item >
        <!-- 仅扫码签到 -->
        <yxt-form-item v-if="formCfg.canScanCodeShowState" prop="canScanCode">
          <yxt-checkbox v-model="form.canScanCode" :true-label="1" :false-label="0">{{ formCfg.canScanCode }}</yxt-checkbox>
        </yxt-form-item>
        <!-- 批阅人 -->
        <yxt-form-item :label="$t('pc_ulcd_lbl_remarkperson')" class="mb0">
          <yxt-radio-group v-model="form.remarkType" :direction="'row'">
            <yxt-radio :label="1">{{ $t('pc_ulcd_lbl_instructorremark') }}</yxt-radio>
            <yxt-radio :label="5">{{ $t('pc_ulcd_lbl_designpersonremark') }}<yxt-button v-if="form.remarkType === 5" type="primary" class="ml16" @click="showUsersBox">{{ $t('pc_ulcd_lbl_designperson') }}</yxt-button></yxt-radio>
          </yxt-radio-group>
        </yxt-form-item>
        <yxt-form-item prop="users">
          <template v-if="form.users.length > 0 && form.remarkType===5">
            <yxt-tag v-for="user in form.users" :key="user.id" type="info" closable class="ml5" @close="delUser(user)"><yxtbiz-user-name :name="user.fullname" /></yxt-tag>
          </template>
        </yxt-form-item>
        <!-- 学员评价（集团标识groupOrgFlag:默认0，1为集团项目 隐藏当前选项）-->
        <yxt-form-item :label="$t('pc_ulcd_lbl_evaluate')">
          <div class="layout-flex">
            <div class="layout-flex">
              <yxt-form-item
                label-width="0"
                class="d-in-block v-mid"
                prop="targetCheck"
              >
                <yxt-checkbox
                  v-model="form.targetCheck"
                  :disabled="!!form.targetId && qnrCanEdit !== 0 "
                  @change="removeSource"
                >
                  <!-- 学员评价checkbox -->
                  {{
                    $t('pc_ulcd_lbl_evaluate_stu')
                  }}
                </yxt-checkbox
                >
              </yxt-form-item>
              <yxt-form-item
                label-width="0"
                class="d-in-block v-mid"
                prop="targetId"
              >
                <yxt-button
                  v-if="form.targetCheck"
                  type="primary"
                  class="ml12 v-mid"
                  :disabled="!!form.targetId && qnrCanEdit !== 0 "
                  @click="showSelectHandle"
                >
                  <!-- 选择模板 -->
                  {{ $t('pc_ulcd_btn_selecttemplate') }}
                </yxt-button
                >
              </yxt-form-item>
            </div>
            <div
              v-if="form.targetId"
              class="col-flex-1 over-hidden layout-flex layout-align-center"
            >
              <yxt-tooltip
                class="item"
                effect="light"
                :content="form.targetName"
                placement="top"
              >
                <span class="nowrap ellipsis ml8 v-mid">{{
                  form.targetName
                }}</span>
              </yxt-tooltip>
              <ulcd-svg
                v-if="!!form.targetId "
                class="hand c-bf v-mid ml8 hover-primary-6 flex-shrink-0"
                back
                name="close"
                width="20px"
                height="20px"
                @click.native="removeSource"
              />
            </div>
          </div>
        </yxt-form-item>

        <upload-refs
          v-if="visible"
          ref="upload"
          buttonType="second"
          :label=" $t('pc_ulcd_offline_enclosure')"
          :files="form.files"
          :limit="5"
          :app-code="appCode"
        >
          <yxt-tooltip
            slot="toolTip"
            :content="$t('pc_ulcd_msg_filemessage')"
            class="item v-mid ml8"
            effect="light"
            placement="top"
          >
            <ulcd-svg
              width="16px"
              height="16px"
              name="icons/question-cirlce-o"
              back
              class="c-bf"
            />
          </yxt-tooltip>
        </upload-refs>
      </yxt-form>
    </div>
    <div slot="footer">
      <yxt-button plain @click="beforeCloseHandle">{{ $t('pc_ulcd_btn_cancel') }}</yxt-button>
      <yxt-button type="primary" @click="submitHandle">{{ $t('pc_ulcd_btn_done') }}</yxt-button>
    </div>
    <!-- 选择问卷模板 -->
    <yxt-drawer
      :title="$t('pc_ulcd_lbl_select_survey')"
      append-to-body
      destroy-on-close
      :before-close="hiddenSelect"
      :visible.sync="showSelect"
      size="960px"
    >
      <yxtbiz-survey-template
        :type="1"
        functionCode="survey_template"
        dataPermissionCode="investigate_moudle_extent"
        :selected="form.targetId"
        @select="sourceSelect"
      ></yxtbiz-survey-template>
    </yxt-drawer>

    <map-address :mapAddress="currentMapInfo" :visible.sync="centerDialogVisible" @mapAdressChange="mapAdressChange"></map-address>
    <people-select ref="selector" @getUsers="getUsers" :users="form.users" :groupOrgFlag="groupOrgFlag" :bizComponentConfig="bizComponentConfig" :visible.sync="personSelectDialog"/>
  </yxt-drawer>
</template>

<script>
import { dateFormat, getDate } from '../../common/utils.js';
import MapAddress from '../../components/mapSelect.vue';
import PeopleSelect from '../../components/peopleSelect.vue';
import UploadRefs from '../../components/form-item-reference.vue';

// 不同环境下加载的代码不一样，这里要在组件库改一下
// import {commonUtil } from 'yxt-biz-pc';
import { enmuFunctions, getFunStatus } from '../../common/test';

import commonUtil from '../../../../common-util';
// 正常应该在这里注册因为是测试组件，就不注册这里了
// import { enmuFunctions } from '../../../function-points'
import mixin from '../../../../../src/mixins/ulcdComp';
export default {
  mixins: [mixin],
  components: {
    MapAddress,
    PeopleSelect,
    UploadRefs
  },
  data() {
    // 签到、签退时间
    function checkTime(tag, rule, value, callback) {
      let signTime = this.form.signTime || [];
      let signoutTime = this.form.signoutTime || [];

      if (this.type === '1' && signTime.length === 0) {
        if (tag === 'sign') {
          return callback(new Error(this.formCfg.signTime || this.$t('pc_ulcd_lbl_signtime_empty_tip')));
        } else {
          return callback(new Error('签退时间不为空'));
        }
      } else {
        if (signTime[1] && signoutTime[0]) {
          if (signTime[1] > signoutTime[0]) {
            return (tag === 'sign')
              ? callback(new Error(this.$t('pc_ulcd_signtime_tip_noback', [this.formCfg.signTime || this.$t('pc_ulcd_lbl_signtime'), this.formCfg.signoutTime || this.$t('pc_ulcd_lbl_signouttime')])))
              : callback(new Error(this.$t('pc_ulcd_signtime_tip_nofront', [this.formCfg.signoutTime || this.$t('pc_ulcd_lbl_signouttime'), this.formCfg.signTime || this.$t('pc_ulcd_lbl_signtime')])));
          }
          let signTimeEndTime = new Date(signTime[1]);
          signTimeEndTime.setMinutes(signTimeEndTime.getMinutes() + this.form.timeOfAllowLate);
          if (signTimeEndTime > new Date(signoutTime[0])) {
            return callback(new Error(this.$t('pc_ulcd_msg_signendtimeafterstarttime')));
          }
        }
      }
      this.$refs.form.clearValidate(['signTime', 'signoutTime']);
      // }
      callback();
    }
    // 延迟签到分钟
    let checkMinute = (rule, value, callback) => {
      let form = this.form;
      if (form.signTime && form.signoutTime && value) {
        let dateTime = getDate(form.signTime[1]);
        dateTime.setMinutes(dateTime.getMinutes() + value);
        if (dateTime > getDate(form.signoutTime[0])) {
          return callback(new Error(this.$t('pc_ulcd_msg_signendtimeafterstarttime')));
        }
      }
      callback();
    };
    let validateAddress = (rule, value, callback) => {
      if (this.form.canFence === 1 && !value) return callback(new Error(this.$t('pc_ulcd_placeholder_attendaddress')));
      callback();
    };
    let validateDetailAddress = (rule, value, callback) => {
      if (this.form.canFence === 1 && !value) return callback(new Error(this.$t('pc_ulcd_placeholder_detailaddress')));
      callback();
    };
    return {
      personSelectDialog: false, // 选人组件
      type: '1', // '1'-添加考勤 '2'-面授中考勤
      formCfg: {
        name: this.$t('pc_ulcd_lbl_signname'),
        nameShowState: true,
        signTime: this.$t('pc_ulcd_lbl_signtime'),
        signTimeShowState: true,
        sigInPwd: this.$t('pc_ulcd_lbl_signinpwd'),
        sigInPwdShowState: true,
        timeOfAllowLate: this.$t('pc_ulcd_lbl_latesign'),
        timeOfAllowLateShowState: true,
        lateFlag_allowLate: [ this.$t('pc_ulcd_lbl_allowstudentstobelate'), this.$t('pc_ulcd_lbl_minute') ],
        signoutTime: this.$t('pc_ulcd_lbl_signouttime'),
        signoutTimeShowState: true,
        sigOutPwd: this.$t('pc_ulcd_lbl_signoutpwd'),
        sigOutPwdShowState: true,
        locationName: this.$t('pc_ulcd_lbl_attendaddress'),
        locationNameShowState: true,
        address: '',
        addressShowState: true,
        canFence: '',
        canFenceShowState: true,
        canScanCode: this.$t('pc_ulcd_lbl_scancodesignin'),
        canScanCodeShowState: true
      },
      pulishedConfig: {
      },
      AppID: '1573257608393580545', // stg环境 id
      // AppID: '1567452187290396673', // tp环境 id
      // AppID: '1548875279827580930', // tcdev id
      rules: {
        name: [{ required: true, message: this.$t('pc_ulcd_msg_signname'), trigger: 'blur' }],
        signTime: [{ required: true, validator: checkTime.bind(this, 'sign'), trigger: 'change' }],
        signoutTime: [{ required: true, message: '签退不能为空', trigger: 'blur' }],
        timeOfAllowLate: [{ validator: checkMinute, trigger: 'blur' }],
        sigInPwd: [{ required: true, message: '不能为空', trigger: 'blur' }],
        sigOutPwd: [{ required: true, message: '不能为空', trigger: 'blur' }]
      },
      size: '500px',
      title: '考勤',
      validateAddress: validateAddress,
      validateDetailAddress: validateDetailAddress,
      form: {
        name: '', // 考勤名字
        sigInPwd: '', // 签到口令
        sigOutPwd: '', // 签退口令
        signTime: [], // 签到日期
        timeOfAllowLate: 0, // 延迟签到分钟
        signoutTime: [], // 签退日期
        locationName: '', // 考勤定位地址
        address: '', // 考勤详细地址
        canFence: 2, // 是否开启电子围栏
        attendanceRange: 3, // 默认考勤范围为3km
        canAudit: 2, // 是否允许旁听
        canScanCode: 0, // 是否开启扫码签到
        lng: '', // 经度
        lat: '', // 纬度
        users: [],
        remarkType: 1, // 批阅方式
        files: [], // 上传文件列表
        targetCheck: false, // 学员评价
        qnrCanEdit: 0, // 学员评价问卷是否可编辑 0-可编辑 其余为不可编辑
        targetName: '', // 问卷模板名称
        targetId: '' // 问卷模板ID
      },
      centerDialogVisible: false,
      // 当前地图信息
      currentMapInfo: {
        obj: {},
        address: '',
        geolocation: []
      },
      showSelect: false
    };
  },
  computed: {
    functionPoints() {
      let code = commonUtil.checkTimeOutFnc(enmuFunctions.ATTEND_SET_LBS);
      return getFunStatus(code);
    },
    lateMinuteRange() {
      let { signTime, timeOfAllowLate } = this.form;
      if (signTime && timeOfAllowLate > 0) {
        let dateTime = getDate(signTime[1]);
        return `${dateFormat(dateTime, 'yyyy-MM-dd HH:mm')} - ${dateFormat(dateTime.setMinutes(dateTime.getMinutes() + timeOfAllowLate), 'yyyy-MM-dd HH:mm')}`;
      }
      return '';
    },
    // 签到日期选项
    signPickerOptions() {
      return {
        disabledDate(date) {
          return date.getTime() < Date.now() - 8.64e7;
        }
      };
    },
    // 签退日期选项
    signoutPickerOptions() {
      return {
        disabledDate(date) {
          return date.getTime() < Date.now() - 8.64e7;
        }
      };
    }
  },
  watch: {
    visible: {
      handler(nval, oval) {
        this.setPageConfig();
        if (nval === true) {

        } else {
          // 老ulcd应用不会销毁数据，所以要手动清理表单
          this.resetAllData();
        }
      },
      immediate: true
    },
    taskBase(val) {
      if (val) {
        // 兼容老ulcd应用先开抽屉再拿数据的情况
        this.setFormData();
      }
    },
    // 签到时间
    'form.signTime'(val) {
      if (!val) {
        this.form.sigInPwd = '';
        this.form.timeOfAllowLate = 0;
      }
    },
    'form.signoutTime'(val) {
      if (!val) {
        this.form.sigOutPwd = '';
      }
    }
  },
  async created() {
    await commonUtil.preCheckFunctions(enmuFunctions);
    console.log(this.functionPoints);
  },
  mounted() {
    this.setConfig();
  },
  methods: {
    getBizData() {
      let bizData = JSON.parse(JSON.stringify(this.bizData));
      // let form = JSON.parse(JSON.stringify(this.form))
      let { signTime, signoutTime, ...form } = this.form;
      signTime = signTime || [];
      signoutTime = signoutTime || [];
      let formData = {
        ...form,
        type: 1,
        orgId: this.orgId,
        versionCode: '0002',
        sigInStart: signTime[0],
        sigInEnd: signTime[1],
        sigOutStart: signoutTime[0],
        sigOutEnd: signoutTime[1]
      };
      const taskBase = JSON.parse(JSON.stringify(this.taskBase));
      bizData.taskBase.name = formData.name;
      bizData.taskBase = Object.assign(taskBase, bizData.taskBase);
      delete formData.name;
      bizData.taskInfo = formData;
      return bizData;
    },
    submitHandle() { // 完整业务数据，可为单条数据，也可为多条组合数据
      this.$refs['form'].validate((valid) => {

        if (valid) {
          let bizData = this.getBizData();
          this.submitEmit(bizData);
          console.log('submitHandle');// 此数据代表用户选择或提交的表单数据，为完整的业务记录数据
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancelHandle() { // 业务数据，可为null
      let bizData = this.getBizData();
      this.cancelEmit(bizData);
      console.log('cancelHandle');// 此数据代表用户已填表单数据，可能是部分表单数据
    },
    draftSaveHandle() { // 业务数据
      let bizData = this.getBizData();
      this.draftSaveEmit(bizData);
      console.log('draftSaveHandle');// 此数据代表用户已填表单数据，可能是部分表单数据
    },
    // TODO 这里缺了数字和默认值的处理
    beforeCloseHandle() {
      let hasValue = false;
      for (let key in this.form) {
        let val = this.form[key];
        switch (Object.prototype.toString.call(val)) {
          case '[object String]' :
            if (val !== '') { hasValue = true; } break;
          case '[object Boolean]]' :
            if (val) { hasValue = true; } break;
          case '[object Array]]' :
            if (val.length > 0) { hasValue = true; } break;
        }
      }
      if (hasValue) {
        // 这里弹框
        this.$confirm('是否保存草稿？')
          .then(_ => {
            this.draftSaveHandle();
          })
          .catch(_ => {
            this.draftCleanTest();
          });
      } else {
        this.cancelHandle();
      }
    },
    setConfig() {
      this.setPageConfig();
      this.setBizConfig();
    },
    setPageConfig() {
      this.setBizData();
      const keys = Object.keys(this.pagePropertyConfig);
      keys.forEach((key) => {
        const val = this.pagePropertyConfig[key];
        const { required, showState, otherName, otherNameInternalKey } = val;
        this.formCfg[`${key}ShowState`] = showState;
        this.formCfg[key] = (otherNameInternalKey && this.$t(otherNameInternalKey)) || otherName || this.formCfg[key];

        if (this.rules[key]) {
          if (required) {
            this.rules[key][0]['required'] = Boolean(required);
          } else {
            this.rules[key] = [];
          }
        }
        if (this.oprateType === 1) {
          this.form[key] = val['defVal'];
        }
      });
    },
    setBizConfig() {
      // const { title, size } = this.bizComponentConfig
    },
    draftCleanTest() {

      this.cancelHandle();

    },
    resetForm() {
      if (this.$refs['form'] && typeof this.$refs['form'].resetFields === 'function') {
        this.$refs['form'].resetFields();
        this.$refs['form'].clearValidate();
      }
    },
    resetData() {
      this.formCfg = {
        name: this.$t('pc_ulcd_lbl_signname'),
        nameShowState: true,
        signTime: this.$t('pc_ulcd_lbl_signtime'),
        signTimeShowState: true,
        sigInPwd: this.$t('pc_ulcd_lbl_signinpwd'),
        sigInPwdShowState: true,
        timeOfAllowLate: this.$t('pc_ulcd_lbl_latesign'),
        timeOfAllowLateShowState: true,
        lateFlag_allowLate: [ this.$t('pc_ulcd_lbl_allowstudentstobelate'), this.$t('pc_ulcd_lbl_minute') ],
        signoutTime: this.$t('pc_ulcd_lbl_signouttime'),
        signoutTimeShowState: true,
        sigOutPwd: this.$t('pc_ulcd_lbl_signoutpwd'),
        sigOutPwdShowState: true,
        locationName: this.$t('pc_ulcd_lbl_attendaddress'),
        locationNameShowState: true,
        address: '',
        addressShowState: true,
        canFence: '',
        canFenceShowState: true,
        canScanCode: this.$t('pc_ulcd_lbl_scancodesignin'),
        canScanCodeShowState: true
      };
      this.pulishedConfig = {};
      this.bizData = {
        meta: { taskId: '', taskVersion: '' },
        taskInfo: {},
        taskBase: {
          name: ''
        }
      };
      this.centerDialogVisible = false;
      this.currentMapInfo = {
        obj: {},
        address: '',
        geolocation: []
      };
    },
    resetAllData() {
      this.resetData();
      this.$nextTick(()=>{
        this.resetForm();
      });
    },
    // 地图选择后赋值
    mapAdressChange(mapInfo) {
      this.form.locationName = mapInfo.address;
      this.form.lng = mapInfo.geolocation[0];
      this.form.lat = mapInfo.geolocation[1];
    },
    // 选择地址
    selectAdress() {
      this.centerDialogVisible = true;
    },
    setFormData() {
      this.bizData.meta = { taskId: this.AppID, taskVersion: this.taskVersion };
      const { sigInStart, sigInEnd, sigOutStart, sigOutEnd, ...form } = JSON.parse(JSON.stringify(this.taskInfo));
      form.files = Array.isArray(form.files) ? this.$refs.upload.formatFiles(form.files) : [];
      form.targetCheck = !!form.targetId;
      this.qnrCanEdit = form.qnrCanEdit;
      let signTime = (sigInStart && sigInEnd) ? [sigInStart, sigInEnd] : [];
      let signoutTime = (sigOutStart && sigOutEnd) ? [sigOutStart, sigOutEnd] : [];
      const { name } = this.taskBase;
      Object.assign(this.form, form, { name, signTime, signoutTime });
    },
    delUser(user) {
      this.form.users.splice(this.form.users.indexOf(user), 1);
      // this.formRef.validateField('users')
    },
    showUsersBox() {
      this.personSelectDialog = true;
    },
    async getUsers(val) {
      this.form.users = val;
      // this.personSelectDialog = false;
      console.log(val, this.form.remarkType);
    },
    // 选择模板、试卷、课件等
    sourceSelect(data) {
      // console.log(data)
      data = (Array.isArray(data) ? data[0] : data) || {};
      let formKeys = this.formKeys || { name: 'name' };
      let form = this.form;
      form.targetId = data.id || '';
      form.targetName = data[formKeys.name] || '';
      // 额外属性
      let attr = formKeys.attr || {};
      Object.keys(attr).forEach(k => {
        if (k === 'shareFlag') {
          if (data[attr[k]] === 1 || data['sourceType'] === 3) {
            form[k] = 1;
          }
        } else {
          form[k] = data[attr[k]];
        }
      });
      data.id && (this.showSelect = false);
      this.sourceChange && this.sourceChange(data);
      // this._sourceSelect && this._sourceSelect(data)
      this.$nextTick().then(() => {
        this.formRef.validateField('targetId');
      });
    },
    removeSource() {
      this.form.targetId = '';
      this.form.targetName = '';
    },
    showSelectHandle() {
      this.showSelect = true;

    },
    hiddenSelect() {

      this.showSelect = false;
    }
  }
};
</script>
<style lang="scss" scoped>
  .version-header{
    display: flex;
  }
</style>